module.exports = __webpack_public_path__ + "img/ethiopia.7f907df8.png";